import Vue from 'vue'
import Router from 'vue-router'
import Tutorials from '@/containers/dashboard/Tutorials'
import Quizzes from '@/containers/dashboard/Quizzes'
import KnowledgeBases from '@/containers/dashboard/KnowledgeBases'
import Categories from '@/containers/dashboard/Categories'
import Users from '@/containers/dashboard/Users'
import Settings from '@/containers/dashboard/Settings'

import DescribeKnowledgeBase from '@/containers/dashboard/knowledgebases/DescribeKnowledgeBase'


import Describe from '@/containers/dashboard/template/Describe'
import DescribeCategory from '@/containers/dashboard/categories/DescribeCategory'
import BuildCategory from '@/containers/dashboard/categories/BuildCategory'
//import PreviewCategory from '@/containers/dashboard/categories/PreviewCategory'
import DescribeQuiz from '@/containers/dashboard/quizzes/DescribeQuiz'
import AssignQuiz from '@/containers/dashboard/quizzes/AssignQuiz'
import Build from '@/containers/dashboard/template/Build'
import BuildQuiz from '@/containers/dashboard/quizzes/BuildQuiz'
import PreviewQuiz from '@/containers/dashboard/quizzes/PreviewQuiz'
import TakeQuiz from '@/containers/dashboard/quizzes/TakeQuiz'
import QuizResults from '@/containers/dashboard/quizzes/QuizResults'
import BuildQuizAddQuestions from '@/containers/dashboard/quizzes/BuildQuizAddQuestion'
import Preview from '@/containers/dashboard/template/Preview'

import EditTutorial from '@/containers/dashboard/template/EditTutorial'

import ResendAlt from '@/containers/authentication/ResendAlt'
import LoginAlt from '@/containers/authentication/LoginAlt.vue'
import PlanSelection from '@/containers/authentication/PlanSelection.vue'

import InvitationAlt from '@/containers/authentication/InvitationAlt.vue'
import Home from '@/containers/Home.vue'
import HomeAlt from '@/containers/HomeAlt.vue'
import Viewer from '@/containers/Viewer.vue'
import Quiz from '@/containers/Quiz.vue'


import Signup from '@/containers/authentication/Signup.vue'
import ConfirmAlt from '@/containers/authentication/ConfirmAlt.vue'
// import Dashboard from '@/components/Dashboard.vue'
import PasswordChange from '@/containers/authentication/PasswordChange.vue'
import PasswordResetAlt from '@/containers/authentication/PasswordResetAlt.vue'
import PasswordResetConfirmAlt from '@/containers/authentication/PasswordResetConfirmAlt.vue'
import cognitoAuth from '@/plugins/cognito'
import Sidebar from '@/components/Sidebar.vue'

Vue.use(Router)

function requireAuth (to, from, next) {
  cognitoAuth.isAuthenticated((err, loggedIn) => {
    console.log("got auth response: ", loggedIn)
    if (err) return next()
    if (!loggedIn) {
      next({
        path: '/',
        query: { redirect: to.fullPath }
      })
    } else {
      next()
    }
  })
}

function tutorialsRedirect (to, from, next) {
  cognitoAuth.isAuthenticated((err, loggedIn) => {
    if (err) return next()
    if (loggedIn) {
      next({
        path: '/tutorials'
        // query: { redirect: to.fullPath }
      })
    } else {
      next()
    }
  })
}

function dashboardRedirect (to, from, next) {
  if (window.location.hash.match("#/viewer")) {
    window.location = window.location.href.replace("/viewer/", "/s/")
    return
  } else if (window.location.hash.match("#tutorial")) {
    window.location = window.location.href.replace("/viewer.html#tutorial/", "/s/")
    return
  }

  // return
  cognitoAuth.isAuthenticated((err, loggedIn) => {
    if (err) return next()
    if (loggedIn) {
      next({
        path: '/tutorials',
        query: { redirect: to.fullPath }
      })
    } else {
      next()
    }
  })
}

export default new Router({
  linkActiveClass: 'active',
  mode: 'history',
  base: __dirname,
  routes: [

    {
      path: '/',
      name: 'HomeAlt',
      component: HomeAlt,
      // beforeEnter: tutorialsRedirect
      beforeEnter: dashboardRedirect
    },
    {
      path: '/viewer/:id',
      name: 'Viewer_alt',
      component: Viewer
      // beforeEnter: tutorialsRedirect
      // beforeEnter: dashboardRedirect
    },
    {
      path: '/s/:id',
      name: 'Viewer',
      component: Viewer
      // beforeEnter: tutorialsRedirect
      // beforeEnter: dashboardRedirect
    },
    {
      path: '/quiz/:id',
      name: 'Quiz',
      component: Quiz
      // beforeEnter: tutorialsRedirect
      // beforeEnter: dashboardRedirect
    },
    {
      path: '/register',
      name: 'Register',
      component: HomeAlt
      // beforeEnter: dashboardRedirect
    },
    {
      path: '/tutorials',
      name: 'Tutorials',
      component: Tutorials,
      beforeEnter: requireAuth
    },
    {
      path: '/categories',
      name: 'Categories',
      component: Categories,
      beforeEnter: requireAuth
    },
    {
      path: '/categories/new',
      name: 'New Category',
      props: {
        category_state: 'new'
      },
      component: DescribeCategory,
      beforeEnter: requireAuth
    },
    {
      path: '/categories/describe/:id',
      name: 'Describe Category',
      props: {
        category_state: 'edit'
      },
      component: DescribeCategory,
      beforeEnter: requireAuth
    },
    {
      path: '/categories/build/:id',
      name: 'Build Category',
      props: {
        category_state: 'edit'
      },
      component: BuildCategory,
      beforeEnter: requireAuth
    },
    /*
    {
      path: '/categories/preview/:id',
      name: 'Preview Category',
      props: {
        category_state: 'preview'
      },
      component: PreviewCategory,
      beforeEnter: requireAuth
    },
    */
    {
      path: '/kb',
      name: 'KnowledgeBases',
      component: KnowledgeBases,
      beforeEnter: requireAuth
    },
    {
      path: '/kb/new',
      name: 'New Knowledge Base',
      props: {
        kbs_state: 'new'
      },
      component: DescribeKnowledgeBase,
      beforeEnter: requireAuth
    },
    {
      path: '/quizzes',
      name: 'Quizzes',
      component: Quizzes,
      beforeEnter: requireAuth
    },
    {
      path: '/quizzes/new',
      name: 'New Quiz',
      props: {
        quiz_state: 'new'
      },
      component: DescribeQuiz,
      beforeEnter: requireAuth
    },
    {
      path: '/quizzes/describe/:id',
      name: 'Describe Quiz',
      props: {
        tutorial_state: 'edit'
      },
      component: DescribeQuiz,
      beforeEnter: requireAuth
    },
    {
      path: '/quizzes/assign/:id',
      name: 'Assign Quiz',
      props: {
        tutorial_state: 'edit'
      },
      component: AssignQuiz,
      beforeEnter: requireAuth
    },
    {
      path: '/quizzes/build/:id',
      name: 'Build Quiz',
      component: BuildQuiz,
      beforeEnter: requireAuth
    },
    {
      path: '/quizzes/preview/:id',
      name: 'Preview Quiz',
      component: PreviewQuiz,
      beforeEnter: requireAuth
    },
    {
      path: '/q/t/:id',
      name: 'TakeQuiz',
      component: TakeQuiz,
    },
    {
      path: '/quizzes/results/:id',
      name: 'Quiz Results',
      component: QuizResults,
      beforeEnter: requireAuth
    },
    {
      path: '/quizzes/build/question/:id',
      name: 'Add QUestions to Quiz',
      component: BuildQuizAddQuestions,
      beforeEnter: requireAuth
    },
    {
      path: '/tutorials/new/:article_id',
      name: 'New Tutorial',
      props: {
        tutorial_state: 'new'
      },
      component: Describe,
      beforeEnter: requireAuth
    },
    {
      path: '/tutorials/describe/:id',
      name: 'Describe Tutorial',
      props: {
        tutorial_state: 'edit'
      },
      component: Describe,
      beforeEnter: requireAuth
    },
    {
      path: '/tutorials/build/:id',
      name: 'Build Tutorial',
      component: Build,
      beforeEnter: requireAuth
    },
    {
      path: '/tutorials/preview/:id',
      name: 'Preview',
      component: Preview,
      beforeEnter: requireAuth
    },
    {
      path: '/users',
      name: 'Users',
      component: Users,
      beforeEnter: requireAuth
    },
    {
      path: '/settings',
      name: 'Settings',
      component: Settings,
      beforeEnter: requireAuth
    },
    { path: '/login', component: LoginAlt },
    { path: '/plan-selection', component: PlanSelection },

    { path: '/invitation', component: InvitationAlt },
    { path: '/signup', component: HomeAlt },
    { path: '/confirm', component: ConfirmAlt },
    { path: '/resend', component: ResendAlt },
    { path: '/change_password', component: PasswordChange, beforeEnter: requireAuth },
    { path: '/reset_password', component: PasswordResetAlt },
    { path: '/confirm_reset_password', component: PasswordResetConfirmAlt },
    { path: '/logout',
      beforeEnter (to, from, next) {
        cognitoAuth.logout()
        location.replace('http://fyi.io')
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js